import { BannerId } from '../../../typings/banners';

export const DELETE_INTERNAL_BANNERS = 'DELETE_INTERNAL_BANNERS';
export type DELETE_INTERNAL_BANNERS = typeof DELETE_INTERNAL_BANNERS;
export interface DeleteInternalBanners {
    type: DELETE_INTERNAL_BANNERS;
    bannersIds: BannerId[];
}

export function deleteInternalBannersAction(bannersIds: BannerId[]): DeleteInternalBanners {
    return {
        type: DELETE_INTERNAL_BANNERS,
        bannersIds
    };
}
